export const AUTO_CAPTURE_MODE = 'AUTO_CAPTURE';
export const MANUAL_CAPTURE_MODE = 'MANUAL_CAPTURE';
export const CAMERA_DISPLAY_STARTED_EVENT = 'CAMERA_DISPLAY_STARTED';
export const CAPTURE_AND_PROCESS_FRAME_COMMAND = 'CAPTURE_AND_PROCESS_FRAME';
export const CAPTURE_FRAME_COMMAND = 'CAPTURE_FRAME';
export const CHECK_BACK_DOC_TYPE = 'CHECK_BACK';
export const CHECK_FRONT_DOC_TYPE = 'CHECK_FRONT';
export const ERROR_EVENT = 'SDK_ERROR';
export const FRAME_CAPTURE_RESULT_EVENT = 'FRAME_CAPTURE_RESULT';
export const FRAME_PROCESSING_FEEDBACK_EVENT = 'FRAME_PROCESSING_FEEDBACK';
export const FRAME_PROCESSING_STARTED_EVENT = 'FRAME_PROCESSING_STARTED';
export const MITEK_ERROR_FOUR_CORNER_EVENT = 'MITEK_ERROR_FOUR_CORNER';
export const SHOW_HINT_EVENT = 'SHOW_HINT';
export const STOP_COMMAND = 'SDK_STOP';

export const MESSAGES = {
  CHECK_FRONT: {
    INIT_EVENT: 'Center Check Front on a dark background',
    MITEK_ERROR_FOUR_CORNER_EVENT:
      'Hold camera directly over check so all 4 corners align with the image'
  },
  CHECK_BACK: {
    INIT_EVENT: 'Center Check Back on a dark background',
    MITEK_ERROR_FOUR_CORNER_EVENT:
      'Hold camera directly over check so all 4 corners align with the image'
  },
  MITEK_ERROR_SKEW_ANGLE: 'Document is skewed.  Hold camera directly over your document',
  MITEK_ERROR_FOCUS: 'Hold steady',
  MISNAP_SUCCESS: 'Success',
  MISNAP_READY_POSE: 'Hold it There',
  MITEK_ERROR_GLARE: 'Reduce Glare',
  MITEK_ERROR_FOUR_CORNER: 'Hold camera directly over check so all 4 corners align with the image',
  MITEK_ERROR_TOO_DARK: 'Lay flat on dark surface in lit area',
  MITEK_ERROR_LOW_CONTRAST: 'Lay flat on dark surface in lit area',
  CV_NO_BARCODE_FOUND: 'Scanning for barcode',
  MITEK_ERROR_TOO_FAR: 'Document Too Far',
  MITEK_ERROR_TOO_CLOSE: 'Document Too Close',
  MITEK_ERROR_NOT_CENTERED: 'Align to example check',
  MITEK_ERROR_MIN_PADDING: 'Move further away',
  MITEK_ERROR_HORIZONTAL_FILL: 'Move the camera closer to your document'
};

export const MITEK_PERMISSION_ERROR = {
  113: {
    title: 'We could not access your device’s camera',
    description: 'Please enable camera access in your settings or try another device.'
  },
  default: {
    title: 'This device cannot use mobile check deposit',
    description: 'Your device does not support this feature. Please try another device.'
  }
};

export const UNSUPPORTED_ERROR = [
  { code: 111, type: 'CONSTRAINT_NOT_SATISFIED' },
  { code: 112, type: 'NO_CAMERA_FOUND' },
  { code: 113, type: 'CAMERA_PERMISSION_DENIED' },
  { code: 120, type: 'CAMERA_UNKNOWN_DEVICE_ISSUE' },
  { code: 333, type: 'USER_MEDIA_NOT_SUPPORTED' },
  { code: 334, type: 'WASM_NOT_SUPPORTED' },
  { code: 335, type: 'DEVICE_NOT_SUPPORTED' },
  { code: 336, type: 'WEBGL_NOT_SUPPORTED' },
  { code: 339, type: 'WEBGL_SHADER_NOT_SUPPORTED' },
  { code: 405, type: 'USER_ACTION_EVENT_REQUIRED' },
  { code: 400, type: 'INVALID_DOCUMENT_TYPE' },
  { code: 330, type: 'SDK_NOT_INITIALIZED' },
  { code: 331, type: 'UNKNOWN_METHOD' },
  { code: 332, type: 'INVALID_COMMAND_SIGNATURE' },
  { code: 337, type: 'INVALID_COMMAND_SIGNATURE' },
  { code: 338, type: 'UNKNOWN_ERROR' }
];

export const UNSUPPORTED_ERROR_CODES = UNSUPPORTED_ERROR.flatMap((error) => error.code);

export const MITEK_SDK_CSS_STYLE_OVERRIDES = `
@media (orientation: portrait) {
  .integrator.CHECK_FRONT,
  .integrator.CHECK_BACK {
    overflow: hidden;
  }
  .integrator.CHECK_FRONT::before,
  .integrator.CHECK_BACK::before {
    content: "";
    position: absolute;
    width: 220%;
    height: 200%;
    transform: rotate(90deg);
    top: -50%;
    left: -230%;
  }
  .integrator.CHECK_FRONT::before {
    background: url('https://res.cloudinary.com/zenbusiness/q_auto,w_32/v1/shared-assets/s2/vector/front-of-check-overlay.svg') no-repeat;
    background-size: contain;
  }
  .integrator.CHECK_BACK::before {
    background: url('https://res.cloudinary.com/zenbusiness/q_auto,w_32/v1/shared-assets/s2/vector/back-of-check-overlay.svg') no-repeat;
    background-size: contain;
  }

  div#mitekHintMessage {
    position: relative;
    left: -45%;
    rotate: 90deg;
    min-width: max-content
  }
}
@media (orientation: landscape) {
  .integrator.CHECK_FRONT {
    background: url('https://res.cloudinary.com/zenbusiness/q_auto,w_32/v1/shared-assets/s2/vector/front-of-check-overlay.svg') no-repeat;
  }
  .integrator.CHECK_BACK {
    background: url('https://res.cloudinary.com/zenbusiness/q_auto,w_32/v1/shared-assets/s2/vector/back-of-check-overlay.svg') no-repeat;
  }

  div#mitekHintMessage {
    position: absolute;
    bottom: 10px;
  }
}
div#mitekHintMessage {
  background: #000;
  color: #fff;
  width: auto;
  padding: 0 10px;
}
div#mitekHintMessage.medium {
  font-size: 13px;
}
`;
